// features/licenses/licenseSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchEsetLicenses = createAsyncThunk(
  'Eset/fetchEsetLicenses',
  async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/eset/licenses`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return res.data;
  }
);

export const fetchEsetDevices = createAsyncThunk(
  'Eset/fetchEsetDevices',
  async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/eset/devices`,
      {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      }
    );
    return res.data;
  }
);

const EsetSlice = createSlice({
  name: 'Eset',
  initialState: {
      licenses: {
        data: [],
        loading: false,
        error: null,
      },
      devices: {
        data: [],
        loading: false,
        error: null,
      },
    },
  reducers: {},
   extraReducers: (builder) => {
    // FETCH LICENSES
    builder
      .addCase(fetchEsetLicenses.pending, (state) => {
        state.licenses.loading = true;
      })
      .addCase(fetchEsetLicenses.fulfilled, (state, action) => {
        state.licenses.loading = false;
        state.licenses.data = action.payload;
      })
      .addCase(fetchEsetLicenses.rejected, (state, action) => {
        state.licenses.loading = false;
        state.licenses.error = action.error.message;
      });

    // FETCH DEVICES
    builder
      .addCase(fetchEsetDevices.pending, (state) => {
        state.devices.loading = true;
      })
      .addCase(fetchEsetDevices.fulfilled, (state, action) => {
        state.devices.loading = false;
        state.devices.data = action.payload;
      })
      .addCase(fetchEsetDevices.rejected, (state, action) => {
        state.devices.loading = false;
        state.devices.error = action.error.message;
      });
  },
});

export default EsetSlice.reducer;
